import React from "react";
import Select from "react-select";

const GroupStudentSelector = ({
  selectedGroups,
  groupStudentsMap,
  studentMap,
  groupOptions,
  onUpdate,
  formatOptionLabel,
  serverGet,
}) => {
  // Fetch students from backend based on group type and ID
  const fetchStudentsByGroup = async (groupType, groupId) => {
    try {
      const res = await serverGet(
        `/school/groups/students/${groupType}/${groupId}`
      );
      console.log(res);
      return res.students || [];
    } catch (error) {
      console.error(`Failed to fetch students for group ${groupId}`, error);
      return [];
    }
  };

  const handleGroupSelectionChange = async (newGroups) => {
    const added = (newGroups || []).filter(
      (g) => !selectedGroups.find((sg) => sg.value === g.value)
    );
    const removed = (selectedGroups || []).filter(
      (g) => !newGroups.find((ng) => ng.value === g.value)
    );

    const updatedGroupMap = { ...groupStudentsMap };
    const updatedStudentMap = { ...studentMap };

    // Remove students from deselected groups
    removed.forEach((group) => {
      delete updatedGroupMap[group.value];
      const remainingStudentIds = new Set(
        Object.values(updatedGroupMap).flatMap((set) => Array.from(set))
      );
      Object.keys(updatedStudentMap).forEach((id) => {
        if (!remainingStudentIds.has(id)) {
          delete updatedStudentMap[id];
        }
      });
    });

    // Add students from new groups
    for (const group of added) {
      const students = await fetchStudentsByGroup(group.type, group.value);
      updatedGroupMap[group.value] = new Set(students.map((s) => s.stud_code));
      for (const s of students) {
        const formattedName = `${s.stSurname || ""}, ${s.stPrfName || ""} (${
          s.stYrLvl === 0 ? "Prep" : `Yr ${s.stYrLvl}`
        }, ${s.stHmrm || "?"})`;
        updatedStudentMap[s.stud_code] = {
          ...s,
          stud_name: formattedName,
        };
      }
    }

    onUpdate({
      selectedGroups: newGroups,
      groupStudentsMap: updatedGroupMap,
      studentMap: updatedStudentMap,
    });
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Select Groups
        </label>
        <Select
          isMulti
          options={groupOptions}
          value={selectedGroups}
          onChange={handleGroupSelectionChange}
          formatOptionLabel={formatOptionLabel}
          placeholder="Search and select groups..."
        />
      </div>
    </div>
  );
};

export default GroupStudentSelector;
